import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, INSERT_LINE_BREAK_COMMAND, KEY_ENTER_COMMAND } from 'lexical';

// Shift+Enter already inserts a line break through Lexical's rich-text
// handler. Cmd/Ctrl+Enter is the alias for people who reach for that instead.
export function registerLineBreakShortcut(editor) {
  return editor.registerCommand(
    KEY_ENTER_COMMAND,
    event => {
      if (!event || !(event.metaKey || event.ctrlKey)) return false;
      event.preventDefault();
      return editor.dispatchCommand(INSERT_LINE_BREAK_COMMAND, false);
    },
    COMMAND_PRIORITY_HIGH,
  );
}

export default function LineBreakShortcutPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => registerLineBreakShortcut(editor), [editor]);

  return null;
}
